export default "__VITE_ASSET__Fx4nXf_e__"